import { render, staticRenderFns } from "./BusinessSupportView.vue?vue&type=template&id=e007a0b8&scoped=true"
import script from "./BusinessSupportView.vue?vue&type=script&lang=js"
export * from "./BusinessSupportView.vue?vue&type=script&lang=js"
import style0 from "./BusinessSupportView.vue?vue&type=style&index=0&id=e007a0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e007a0b8",
  null
  
)

export default component.exports